/**
 * Constants for post-signup onboarding stepper (URLs, value keys only).
 * Labels come from translation namespace "onboarding" (intent.*, volume.*).
 */

import { brandingConfig } from '@/config/branding';

export const HUB_URL =
	import.meta.env.VITE_HUB_URL || brandingConfig.hubUrl || 'https://hub.tagada.io';
export const DOCS_URL =
	import.meta.env.VITE_DOCS_URL || brandingConfig.docsUrl || 'https://docs.tagada.io';
export const CAL_COM_TEAM_URL = brandingConfig.calComTeamSlug
	? `https://cal.com/team/${brandingConfig.calComTeamSlug}`
	: null;

export type IntentValue = 'PROCESSING' | 'CRM' | 'BOTH';

/** Intent option values; use t(`onboarding:intent.${value}`) for label. */
export const INTENT_OPTIONS: { value: IntentValue }[] = [
	{ value: 'PROCESSING' },
	{ value: 'CRM' },
	{ value: 'BOTH' },
];

export const VOLUME_LT_50K = 'lt_50k';

/** Monthly volume option values; use t(`onboarding:volume.${value}`) for label. */
export const MONTHLY_VOLUME_OPTIONS: { value: string }[] = [
	{ value: VOLUME_LT_50K },
	{ value: '50k_150k' },
	{ value: '150k_500k' },
	{ value: '500k_1m' },
	{ value: '1m_plus' },
];
